import { CircuitRoomForm, CircuitRoomLocalization } from "../objects/circuitRoom";
import { CircuitRoomListConfiguration, CircuitRoomListCriteria, CircuitRoomListFiltersCriteria } from "../objects/circuitRoomList";
import { Column } from "../objects/column";


export const EMPTY_ROOM: CircuitRoomForm = {
    id: 0,
    name: "",
    description: "",
    localization: [],
    name_locales: {},
    description_locales: {},
    allowed_meal_plans: [],
    room_min_adult: '',
    room_max_adult: '',
    room_min_child: '',
    room_max_child: '',
    forbidden_compositions: [],
};

export const EMPTY_ROOM_LOCALIZED: CircuitRoomLocalization = {
    name: "",
    description: "",
    locale: 0
};



export const EMPTY_ROOM_FILTERS: CircuitRoomListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_ROOM_LIST_CRITERIA: CircuitRoomListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_ROOM_FILTERS,
    search: ''
};



export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_ROOM_LIST_CONFIGURATION: CircuitRoomListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const CIRCUIT_ROOM_MODULE = 'CIRCUIT_ROOM_MODULE';